import { MenuControllerFactoryService, MenuControllerId, MenuItem } from '@adaptiva/core/menus';
import { EJavaClassNames, ServerObjectMultiMenuController } from '@adaptiva/data-service';
import { inject, Injectable } from '@angular/core';
import { EMPTY, Observable, of, switchMap } from 'rxjs';
import { LlmConversation } from '../classes';

@Injectable()
export class LlmConversationHeaderMultiMenuController extends ServerObjectMultiMenuController<LlmConversation> {

	public static override readonly id: MenuControllerId.Any = `${MenuControllerId.Prefix.Default}${LlmConversation.className}`;

	public override readonly deleteMenuName: string = 'Delete Selected Chats';

	protected readonly menuControllerFactory: MenuControllerFactoryService = inject(MenuControllerFactoryService);

	public override getClassName(): string {
		return EJavaClassNames.LlmConversation;
	}

	public override generate(_conversation: LlmConversation[]): Observable<MenuItem<LlmConversation[]>[]> {
		return of([
			this.getDeselectAllMenuItem(),
			this.getDeleteMenuItem(),
		]);
	}

	protected override delete(_item: MenuItem<LlmConversation[]>): void {
		const _selections: LlmConversation[] = this.selectionManager.toArray();
		const _className: string = _selections[0].javaClassName;
		const [_objectIds, _objectNames]: [long[], string[]] = _selections.reduce((_output: [long[], string[]], _selection: LlmConversation) => {
			_output[0].push(_selection.objectId);
			_output[1].push(_selection.displayName);

			return _output;
		}, [[], []]);

		this.overlays.confirm(
			'Are you sure?',
			`Deleting the following ${_selections.length} objects cannot be undone:\n${_objectNames.join('\n')}`
		).pipe(
			switchMap((_isConfirmed: boolean) => {
				if (!_isConfirmed)
					return EMPTY;

				return this.objectManager.deleteObjectsByIds(_className, _objectIds);
			})
		).subscribe({
			next: () => {
				this.snackbars.display(`Successfully deleted ${_selections.length} objects`);
				this.selectionManager.remove(..._selections);
			},
			error: (e: Error) => {
				this.errorHandler.defaultErrorHandler(e, 'LlmConversationHeaderMultiMenuController.onDelete');
			}
		});
	}

}
